module.exports = __webpack_public_path__ + "static/media/section-3.f08269a7.svg";